import { ShipFrom } from './ship-from.model';
import { ShipTo } from './ship-to.model';
import { ShippingPackages } from './shipping-packages.model';
import { WeightUnits } from './weight-units.model';

export class ShippingEstimatesRequest {
  carrierServiceCode: string[];
  requireDryIceShipment: boolean;
  dryIceWeight: number;
  dryIceWeightUnit: WeightUnits;
  billingCurrencyCode: string;
  shipFrom: ShipFrom;
  shipTo: ShipTo;
  shippingPackages: ShippingPackages[];
}
